export const READ_TRAINING_FILES = 'READ_TRAINING_FILES';
export const CREATE_TRAINING_FILE = 'CREATE_TRAINING_FILE';
export const UPDATE_TRAINING_FILE = 'UPDATE_TRAINING_FILE';
export const DELETE_TRAINING_FILE = 'DELETE_TRAINING_FILE';

// eslint-disable-next-line no-shadow
export const readTrainingFilesAction = (activities, queryId = 'default') => ({
  type: READ_TRAINING_FILES,
  payload: {
    activities,
    queryId,
  },
});

export const createTrainingFileAction = (
  trainingFile,
  queryId = 'default',
) => ({
  type: CREATE_TRAINING_FILE,
  payload: {
    trainingFile,
    queryId,
  },
});

export const updateTrainingFileAction = (
  trainingFile,
  queryId = 'default',
) => ({
  type: UPDATE_TRAINING_FILE,
  payload: {
    trainingFile,
    queryId,
  },
});

export const deleteTrainingFileAction = (
  trainingFileId,
  queryId = 'default',
) => ({
  type: DELETE_TRAINING_FILE,
  payload: {
    trainingFileId,
    queryId,
  },
});

const initialTrainingFiles = { default: {} };

export function trainingFiles(state = initialTrainingFiles, action) {
  switch (action.type) {
    case READ_TRAINING_FILES: {
      const newState = {
        ...state,
        [action.payload.queryId]: { ...state[action.payload.queryId] },
      };
      action.payload.activities.forEach((p) => {
        newState[action.payload.queryId][p._id] = p;
      });
      return newState;
    }
    case CREATE_TRAINING_FILE:
      return {
        ...state,
        [action.payload.queryId]: {
          ...state[action.payload.queryId],
          [action.payload.trainingFile._id]: action.payload.trainingFile,
        },
      };
    case UPDATE_TRAINING_FILE: {
      const current =
        (state[action.payload.queryId] &&
          state[action.payload.queryId][action.payload.trainingFile._id]) ||
        undefined;
      return {
        ...state,
        [action.payload.queryId]: {
          ...state[action.payload.queryId],
          [action.payload.trainingFile._id]: {
            ...current,
            ...action.payload.trainingFile,
          },
        },
      };
    }
    case DELETE_TRAINING_FILE: {
      const { trainingFileId } = action.payload;
      return Object.entries(state).reduce((prev, [key, val]) => {
        prev[key] = {
          ...val,
          [trainingFileId]: undefined,
        };
        return prev;
      }, {});
    }
    default:
      return state;
  }
}
